var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExternalLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H7V3H2V13H12V8H14V15H0V1Z",
    fill: "#7E858A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 0H15V6.4L12.5 3.9L7.4 9L6 7.6L11.1 2.5L8.6 0Z",
    fill: "#7E858A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExternalLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/externalLink.9917e1ef1ae048ca4998ce396b878aff.svg";